<div class="container-fluid p-0 h-100">
    <div class="row quick-view-card-row">
        <div class="col-md-12 col-lg-4 quick-view-card-column">
            <div class="dashboard-quick-card dashboard-welcome-card h-100">
            <div class="d-flex align-items-center welcome-card-title font-weight-bolder">
                <span class="pr-2"
                    ><img id="profimgsize" class="imageAlign rounded h-25px w-25px" src="/assets/common/images/photos/Dashboard_title.png"
                /></span>
                <span class="mt-0-3">{{ "WelcomeBack" | localize }}</span>
            </div>
            <div *ngIf="isLoaded && !isEmpty" class="d-flex checkImge welcome-user-row">
                <div class="users_img welcome-profile-image">
                    <span class="label-circle"></span>
                    <span
                        class="overlays label label-dot status-icon"
                        pTooltip="{{ getUserStatus(currentUserStatus) }}"
                        tooltipPosition="top"
                        [ngClass]="statusOptions[currentUserStatus]"
                    ></span>

                    <div class="d-flex align-items-center" *ngIf="userDetails.profileImage">
                        <div class="rounded welcome-profile-avatar">
                            <img [src]="userDetails.profileImage" id="profimgsize" class="border border-light rounded welcome-profile-avatar" />
                        </div>
                    </div>
                    <div class="d-flex align-items-center" *ngIf="!userDetails.profileImage">
                        <div class="rounded welcome-profile-avatar">
                            <img class="welcome-profile-avatar" src="assets/common/images/default-profile-picture1.svg" style="" id="profimgsize" />
                        </div>
                    </div>
                </div>
                <div class="welcome-user-details">
                    <h2
                        class="font-weight-boldest intime-open-sans welcome-user-name"
                        pTooltip="{{ userDetails.userName }}"
                        [tooltipDisabled]="userDetails.userName | tooltipDisabled:16"
                        tooltipPosition="bottom"
                    >
                        {{ userFullname(userDetails.userName) | slice : 0 : 15 }}{{ userFullname(userDetails.userName).length > 15 ? ".." : "" }}
                    </h2>
                    <span class="userDetails welcome-user-meta" tooltipPosition="bottom">
                        <span>{{ getDate | date : "fullDate" }}</span>
                        <span class="welcome-location">
                        <img *ngIf="!userDetails.userCurrentLocation" src="assets/common/images/Activities/google-maps.svg" class="mr-1" />
                        <img
                            id="locationimg"
                            *ngIf="userDetails.userCurrentLocation && workingType == 1"
                            pTooltip="Work From Home"
                            tooltipPosition="bottom"
                            src="assets/common/images/Activities/wfh.svg"
                            class="mr-1"
                        />
                        <img
                            id="locationimg"
                            *ngIf="userDetails.userCurrentLocation && workingType == 3"
                            pTooltip="Work From Remote"
                            tooltipPosition="bottom"
                            src="assets/common/images/Activities/wfr.svg"
                            class="mr-1"
                        />
                        <img
                            id="locationimg"
                            *ngIf="userDetails.userCurrentLocation && workingType == 2"
                            pTooltip="Work From Office"
                            tooltipPosition="bottom"
                            src="assets/common/images/Activities/wfo.svg"
                            class="mr-1"
                        />
                        {{ userDetails.userCurrentLocation ? userDetails.userCurrentLocation : ("Offline" | localize) }}
                        </span>
                    </span>
                    <span *ngIf="!isLoaded && isEmpty" class="h6 shimmeralignment">
                        <ngx-shimmer-loading [width]="'100px'" [height]="'25px'" class=""></ngx-shimmer-loading>
                    </span>
                </div>
            </div>
            <div *ngIf="!isLoaded && isEmpty" class="welcome-card-shimmer mt-4">
                <div class="d-flex align-items-center">
                    <ngx-shimmer-loading [width]="'48px'" [height]="'48px'"></ngx-shimmer-loading>
                    <div class="ml-3 flex-grow-1">
                        <ngx-shimmer-loading [width]="'170px'" [height]="'20px'"></ngx-shimmer-loading>
                        <ngx-shimmer-loading [width]="'220px'" [height]="'12px'"></ngx-shimmer-loading>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between mt-8">
                    <ngx-shimmer-loading [width]="'165px'" [height]="'54px'"></ngx-shimmer-loading>
                    <div class="welcome-active-time-shimmer">
                        <ngx-shimmer-loading [width]="'90px'" [height]="'24px'"></ngx-shimmer-loading>
                        <ngx-shimmer-loading [width]="'70px'" [height]="'12px'"></ngx-shimmer-loading>
                    </div>
                </div>
                <div class="mt-6">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'9px'"></ngx-shimmer-loading>
                    <div class="d-flex justify-content-between mt-2">
                        <ngx-shimmer-loading [width]="'45px'" [height]="'10px'"></ngx-shimmer-loading>
                        <ngx-shimmer-loading [width]="'45px'" [height]="'10px'"></ngx-shimmer-loading>
                    </div>
                </div>
                <div class="welcome-activity-row welcome-activity-shimmer">
                    <div class="welcome-activity-strip">
                        <div class="welcome-activity-section">
                            <ngx-shimmer-loading [width]="'28px'" [height]="'28px'"></ngx-shimmer-loading>
                            <div class="welcome-activity-text">
                                <ngx-shimmer-loading [width]="'90px'" [height]="'12px'"></ngx-shimmer-loading>
                                <ngx-shimmer-loading [width]="'70px'" [height]="'10px'"></ngx-shimmer-loading>
                            </div>
                        </div>
                        <div class="welcome-activity-divider"></div>
                        <div class="welcome-activity-section welcome-device-section">
                            <ngx-shimmer-loading [width]="'30px'" [height]="'30px'"></ngx-shimmer-loading>
                            <div class="welcome-activity-text">
                                <ngx-shimmer-loading [width]="'90px'" [height]="'12px'"></ngx-shimmer-loading>
                                <ngx-shimmer-loading [width]="'60px'" [height]="'10px'"></ngx-shimmer-loading>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="isLoaded && !isEmpty" class="d-md-flex welcome-time-row">
                <div class="col-md-6 col-lg-4 pl-0 welcome-clock-action">
                    <button
                        type="button"
                        *ngIf="userCurrentStatus !== 'CheckIn'"
                        class="btn btn-danger rounded cursor-pointer"
                        (click)="startAndStopTimer()"
                    >
                        <div class="row align-items-center">
                            <div class="col-md-3">
                                <div>
                                    <img src="../../../../../assets/common/images/Activities/AlarmIconDash.svg" height="25" />
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="row text-left">
                                    <div class="col-md-12 font-weight-bold">
                                        {{ "ClockOut" | localize }}
                                    </div>
                                    <div class="col-md-12">
                                        {{ getLocalJsDate(checkInTime) | date : "hh:mm a" }}
                                        {{ getDate | date : "hh:mm a" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </button>
                    <button
                        type="button"
                        *ngIf="userCurrentStatus === 'CheckIn'"
                        class="btn checkInColor rounded cursor-pointer"
                        (click)="startAndStopTimer()"
                    >
                        <div class="row align-items-center">
                            <div class="col-3">
                                <div>
                                    <img src="../../../../../assets/common/images/Activities/AlarmIconDash.svg" height="25" />
                                </div>
                            </div>
                            <div class="col-9">
                                <div class="row text-left">
                                    <div class="col-md-12 font-weight-bold text-white">
                                        {{ "ClockIn" | localize }}
                                    </div>
                                    <div class="col-md-12 text-white">
                                        {{ getLocalJsDate(checkInTime) | date : "hh:mm a" }}
                                        {{ getDate | date : "hh:mm a" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </button>
                </div>
                <div class="col-md-6 col-lg-4 mt-3 welcome-active-time" *ngIf="this.userCurrentStatus === 'CheckIn'">
                    <div class="row">
                        <span class="my-auto font-weight-bolder text-primary line-height-sm" style="font-size: 1.55rem; display: flex">
                            <span *ngIf="!isLoaded"><ngx-shimmer-loading [width]="'90px'" [height]="'26px'"></ngx-shimmer-loading></span>
                            <span *ngIf="isLoaded">
                                {{ activeTime }}<span class="font-size-sm pt-3 pl-1"> {{ "h" | localize }}</span></span
                            >
                        </span>
                    </div>
                    <div class="row">
                        <div class="userDate">{{ "ActiveTime" | localize }}</div>
                    </div>
                </div>

                <div class="col-md-6 mt-3 welcome-active-time" *ngIf="this.userCurrentStatus !== 'CheckIn'">
                    <div class="row">
                        <span class="my-auto font-weight-bolder text-primary line-height-sm d-flex align-items-end welcome-active-time-value">
                            {{ activeTime }}
                            <span class="font-size-sm pl-1 pt-3"> {{ "h" | localize }}</span>
                        </span>
                    </div>
                    <div class="row">
                        <div class="userDate">{{ "ActiveTime" | localize }}</div>
                    </div>
                </div>
            </div>
            <div *ngIf="isLoaded && !isEmpty" class="d-md-flex welcome-progress-row">
                <div class="welcome-progress-column mt-4">
                    <div class="row">
                        <div class="col p-0 pr-2" style="text-align: right">
                            <span class="dot bg-danger" *ngIf="isLate"></span>
                            <span class="dot bg-success" *ngIf="!isLate"></span>
                        </div>
                        <div class="col-10 p-0 mt-2">
                            <itp-progress-bar [value]="progressBarForTime"></itp-progress-bar>
                        </div>
                        <div class="col p-0 pl-2">
                            <span class="dot bg-danger" *ngIf="isearly"></span>
                            <span class="dot" *ngIf="!isearly && !isOnTime"></span>
                            <span class="dot bg-success" *ngIf="isOnTime"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="isLoaded && !isEmpty" class="row welcome-progress-label-row">
                <div class="welcome-progress-column">
                    <span class="projDetails"> {{ workStartTempTime | date : "h:mm a" }} </span>
                    <span class="projDetails float-right"> {{ workEndTempTime | date : "h:mm a" }} </span>
                </div>
            </div>

            <div *ngIf="isLoaded && !isEmpty" class="welcome-activity-row">
                <div
                    class="welcome-activity-strip"
                    [ngClass]="{
                        'welcome-activity-strip-single': !(userDetails.applicationName || userDetails.applicationIcon) || !userDetails.deviceName,
                        'welcome-activity-empty': !(userDetails.applicationName || userDetails.applicationIcon) && !userDetails.deviceName
                    }"
                >
                    <div class="welcome-activity-section" *ngIf="userDetails.applicationName || userDetails.applicationIcon">
                        <img *ngIf="userDetails.applicationIcon" [src]="userDetails.applicationIcon" class="img-fluid welcome-activity-icon" />
                        <div class="welcome-activity-text">
                            <span
                                *ngIf="userDetails.applicationName"
                                class="welcome-activity-title"
                                pTooltip="{{ userDetails.applicationName }}"
                                [tooltipDisabled]="userDetails.applicationName | tooltipDisabled:12"
                                tooltipPosition="bottom"
                            >
                                {{ userDetails.applicationName | slice : 0 : 12 }}{{ userDetails.applicationName?.length > 12 ? "..." : "" }}
                            </span>
                            <span *ngIf="userDetails.productivityType == 1" class="welcome-activity-subtitle text-success">
                                {{ "Productive" | localize }}
                            </span>
                            <span *ngIf="userDetails.productivityType == 2" class="welcome-activity-subtitle">
                                {{ "Unproductive" | localize }}
                            </span>
                            <span *ngIf="userDetails.productivityType == 3" class="welcome-activity-subtitle">
                                {{ "Neutral" | localize }}
                            </span>
                        </div>
                    </div>
                    <div class="welcome-activity-divider" *ngIf="(userDetails.applicationName || userDetails.applicationIcon) && userDetails.deviceName"></div>
                    <div class="welcome-activity-section welcome-device-section" *ngIf="userDetails.deviceName">
                        <img
                            *ngIf="userDetails.deviceType == 1 || userDetails.deviceType == 3"
                            src="assets/common/images/device-icon/DesktopMonitorPurple.svg"
                            class="welcome-device-icon"
                        />
                        <img
                            *ngIf="userDetails.deviceType == 2"
                            src="assets/common/images/device-icon/WebApplicationGrey.svg"
                            class="welcome-device-icon"
                        />
                        <img
                            *ngIf="userDetails.deviceType == 4"
                            src="assets/common/images/device-icon/AndroidMobileGray.svg"
                            class="welcome-device-icon"
                        />
                        <img
                            *ngIf="userDetails.deviceType == 5"
                            src="assets/common/images/device-icon/MobileGrey.svg"
                            class="welcome-device-icon"
                        />
                        <div class="welcome-activity-text">
                            <span
                                class="welcome-activity-title"
                                pTooltip="{{ userDetails.deviceName }}"
                                [tooltipDisabled]="userDetails.deviceName | tooltipDisabled:12"
                                tooltipPosition="bottom"
                            >
                                {{ userDetails.deviceName | slice : 0 : 12 }}{{ userDetails.deviceName?.length > 12 ? "..." : "" }}
                            </span>
                            <span class="welcome-activity-subtitle">{{ "Active" | localize }}</span>
                        </div>
                    </div>
                    <div class="welcome-activity-section welcome-empty-section" *ngIf="!(userDetails.applicationName || userDetails.applicationIcon) && !userDetails.deviceName">
                        <span class="welcome-empty-text">{{ "NoDataFound" | localize }}</span>
                    </div>
                </div>
                <div class="border border-radius-4px d-flex mt-4 pl-0 col-md-7" style="border-color: #eeeeee" *ngIf="userDetails.projectName">
                    <div class="d-flex">
                        <div class="flex-grow-0 align-items-center gap-2 d-flex px-3">
                            <div class="d-flex align-items-center">
                                <div class="d-flex">
                                    <span
                                        class="count-badge"
                                        [ngClass]="{
                                            'count-badge-blue': userDetails.taskStateId === 1,
                                            'count-badge-orange': userDetails.taskStateId === 2,
                                            'count-badge-red': userDetails.taskStateId === 3,
                                            'count-badge-green': userDetails.taskStateId === 4
                                        }"
                                    ></span>
                                </div>
                                <div class="d-flex justify-content-center align-items-end rounded w-100">
                                    <img
                                        *ngIf="userDetails.projectName"
                                        src="{{
                                            userDetails.projectIcon
                                                ? userDetails.projectIcon
                                                : 'assets/common/images/new-dashboard/default-project-bag.svg'
                                        }}"
                                        class="h-30px"
                                        id="profimgsize"
                                    />
                                </div>
                            </div>

                            <span class="flex-grow-1 align-items-center ms-2 fw-bold text-decoration-none">
                                <div>
                                    <span
                                        >{{ userDetails.projectName | slice : 0 : 17 }} {{ userDetails.projectName?.length > 17 ? "..." : "" }}</span
                                    >
                                    <p class="mb-0 text-muted">
                                        {{ userDetails.projectDescription | slice : 0 : 17
                                        }}{{ userDetails.projectDescription?.length > 17 ? "..." : "" }}
                                    </p>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-8 quick-view-card-column">
            <div class="dashboard-quick-card dashboard-project-card h-100">
        <div>
            <div class="d-flex justify-content-between">
                <div class="font-weight-bolder">
                    <span class="pr-1">
                        <img
                            id="profimgsize"
                            class="imageAlign border border-light rounded h-25px w-25px"
                            src="/assets/common/images/photos/Dashboard_CurrentProject.svg"
                        />
                    </span>
                    {{ "CurrentProjects" | localize }}
                    <span *ngIf="projectCount > 1" class="badge badge-primary bg-transparent text-primary border-1 p-1 ml-1" style="border: 1px solid">
                        # {{ projectCount }}
                    </span>
                </div>
            </div>

                <div class="mt-1 current-project-content">
                <div class="bg-white flex-grow-1 card-custom-tabs1 position-relative" id="projectsTabs" [class.single-project]="currentProjectDto?.length === 1" *ngIf="isProjectDataLoaded && currentProjectDto?.length">
                    <tabset #projectsTabs>
                        <tab *ngFor="let project of currentProjectDto; index as i; trackBy: trackById">
                            <ng-template tabHeading>
                                <img id="profimgsize"
                                    class="project-tab-icon imageAlign rounded h-35px w-35px p-1"
                                    pTooltip="{{ project.name }}" [tooltipDisabled]="project.name | tooltipDisabled:1"
                                    tooltipPosition="bottom" src="{{
                                        project.projectImage ? project.projectImage : 'assets/common/images/new-dashboard/default-project-bag.svg'
                                    }}" />
                            </ng-template>
                            <div class="d-flex justify-content-between">
                                <div class="mt-4 pl-0">
                                    <div>
                                        <span
                                            class="bg-white font-size-sm font-weight-boldest intime-open-sans mr-2"
                                            pTooltip="{{ project.name }}"
                                            [tooltipDisabled]="project.name | tooltipDisabled:16"
                                            tooltipPosition="bottom"
                                        >
                                            {{ project?.name | slice : 0 : 16 }}{{ project?.name?.length > 16 ? "..." : "" }}
                                        </span>
                                        <span class="text-muted font-size-sm font-weight-bolder">
                                            {{ project.hourlyBudget }} {{ "hrs" | localize }}
                                        </span>
                                    </div>
                                </div>
                                <div class="mt-4 pr-0 text-right">
                                    <span
                                        *ngIf="project?.projectBillingType == 1"
                                        class="label label-outline-secondary label-pill label-inline mr-2"
                                        style="
                                            border-radius: 1.42rem !important;
                                            border-color: rgb(179, 181, 185) !important;
                                            font-size: 0.84rem;
                                            font-weight: 500;
                                        "
                                        ><span
                                            [ngClass]="{
                                                'label-success': project?.projectBillingType == 1,
                                                'label-warning': status == 2,
                                                'label-pill': status == 3
                                            }"
                                            class="label label-dot mr-2"
                                        ></span
                                        >{{ "Billable" | localize }}</span
                                    >
                                    <span
                                        *ngIf="project?.projectBillingType == 2"
                                        class="label label-outline-secondary label-pill label-inline mr-2"
                                        style="
                                            border-radius: 1.42rem !important;
                                            border-color: rgb(179, 181, 185) !important;
                                            font-size: 0.84rem;
                                            font-weight: 500;
                                        "
                                        ><span [ngClass]="{ 'label-warning': project?.projectBillingType == 2 }" class="label label-dot mr-2"></span
                                        >{{ "NonBillable" | localize }}</span
                                    >
                                </div>
                            </div>
                            <div class="d-md-flex justify-content-between current-project-details-row">
                                <div class="current-project-dates mt-4 pl-0">
                                    <div class="table-responsive">
                                        <table class="w-100" cellpadding="0" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <td style="border: 1px solid #e3e3e3">
                                                        <div class="p-3">
                                                            <span class="font-weight-boldest"> {{ project.startDate | date : "MMM d, y" }} </span>
                                                            <div class="text-muted font-size-sm font-weight-bolder">
                                                                {{ "StartDate" | localize }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style="border: 1px solid #e3e3e3">
                                                        <div class="p-3">
                                                            <span class="font-weight-boldest"> {{ project.endDate | date : "MMM d, y" }} </span>
                                                            <div class="text-muted font-size-sm font-weight-bolder">
                                                                {{ "EndDate" | localize }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div class="current-project-progress mt-4 pr-0">
                                    <div class="projDetails">
                                        <span> {{ "ProgressBar" | localize }} </span>
                                    </div>
                                    <itp-progress-bar
                                        [value]="getProjectProgress(project.startDate, project.endDate)"
                                        [showLabel]="true">
                                    </itp-progress-bar>
                                </div>
                            </div>
                            <div class="current-project-footer d-flex justify-content-between align-items-end">
                                <div class="current-project-people d-flex">
                                    <div class="current-project-manager mt-4 pl-0">
                                    <div class="d-flex flex-column text-dark-50">
                                        <span class="font-weight-bolder font-size-sm mb-2">{{ "Manager" | localize }}</span>

                                        <profile-image-chain
                                            [interactive]="false"
                                            [userDetails]="project.assignedProjectManager"
                                            [showConsolidatedViewLink]="false"
                                            class="profile-position"
                                        ></profile-image-chain>
                                    </div>
                                </div>
                                <div class="current-project-team mt-4">
                                    <div class="d-flex flex-column text-dark-50 pl-0">
                                        <span class="font-weight-bolder font-size-sm mb-2">{{ "TeamMember" | localize }}</span>
                                        <profile-image-chain
                                            [interactive]="false"
                                            [userDetails]="project.teamProfileImage"
                                            [showConsolidatedViewLink]="false"
                                            class="profile-position"
                                        ></profile-image-chain>
                                    </div>
                                </div>
                                </div>
                                <div class="current-project-view-link mt-4 pr-0">
                                    <span
                                        (click)="redirectToViewPage(project.id, project.projectType)"
                                        type="button"
                                        class="font-size-14 font-weight-bolder text-primary d-inline-flex align-items-center cursor-pointer"
                                    >
                                        <span class="pt-3px"> {{ "ViewProject" | localize }}</span>
                                        <img class="h-18px w-18px ml-2 img-fluid" src="/assets/common/images/photos/Dashboard_ViewProject.png" />
                                    </span>
                                </div>
                            </div>
                        </tab>
                    </tabset>
                </div>

                <div *ngIf="!isProjectDataLoaded" class="current-project-shimmer current-project-content">
                    <div class="d-flex align-items-center project-shimmer-tabs">
                        <ngx-shimmer-loading
                            *ngFor="let shimmerProjectTab of [1, 2, 3]; trackBy: trackByIndex"
                            [width]="'30px'"
                            [height]="'30px'"
                        ></ngx-shimmer-loading>
                    </div>
                    <div class="mt-4">
                        <ngx-shimmer-loading [width]="'200px'" [height]="'16px'"></ngx-shimmer-loading>
                    </div>
                    <div class="d-md-flex justify-content-between current-project-details-row">
                        <div class="current-project-dates mt-4 pl-0">
                            <ngx-shimmer-loading [width]="'100%'" [height]="'54px'"></ngx-shimmer-loading>
                        </div>
                        <div class="current-project-progress mt-4 pr-0">
                            <ngx-shimmer-loading [width]="'100%'" [height]="'32px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                    <div class="current-project-footer d-flex justify-content-between align-items-end">
                        <div class="current-project-people mt-4 pl-0">
                            <ngx-shimmer-loading [width]="'180px'" [height]="'36px'"></ngx-shimmer-loading>
                        </div>
                        <div class="current-project-view-link mt-4 pr-0">
                            <ngx-shimmer-loading [width]="'105px'" [height]="'16px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                </div>

                <div *ngIf="isProjectDataLoaded && !currentProjectDto?.length" class="current-project-empty-state">
                    <img src="../../../../assets/common/images/new-dashboard/project-empty-ui.svg" class="img-fluid current-project-empty-image" />
                    <h6 class="text-muted mt-4 text-center current-project-empty-text">{{ "NoDataFound" | localize }}</h6>
                </div>
            </div>
        </div>
            </div>
        </div>
    </div>

    <div class="row mb-4 px-8">

    </div>
</div>
